import type { User } from '@/@types/user'
import { currentUserQueryOptions, getUserQueryOptions } from '@/utils/fetchers/user'
import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

export default function useUser(username: string | undefined): User | undefined {
	const { data: user } = useQuery(getUserQueryOptions(username))
	return user
}

export function useCurrentUser(): User {
	const { data: user } = useSuspenseQuery(currentUserQueryOptions)
	return user
}
